const utils = (function($) {
  var methods = {};
  
  methods.getCart = function() {
    return $.getJSON('/cart.js');
  };

  methods.refreshCart = function() {
    return new Promise(function(resolve, reject) {
      methods.getCart().then(function(cart) {
        $('body').trigger('updateCart', cart);
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {detail: {}}));
        resolve();
      });
    });
  };

  methods.addItemsToCart = function(items) {
    return new Promise(function(resolve, reject) {
      async.eachSeries(items, function(item, callback) {
        methods.addItemToCart(item)
        .then(function() {
          callback();
        })
      }, function(err) {
        if (err) {
          console.error(err);
        }

        // After all done
        resolve();
      });
    });
  };

  methods.addItemToCart = function(p_options) {
    var data = {
      quantity: p_options.quantity,
      id: p_options.variant_id,
    };

    if (p_options.properties !== undefined) {
      data['properties'] = p_options.properties;
    }
    console.log(data);

    return new Promise(function(resolve, reject) {
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json',
        success: function(data) { 
          resolve(data);
        },
        error: function(error) { 
          reject(error);
        }
      });
    });      
  };

  methods.removeItemsFromCart = function(p_options) {
    var updates = {};
    
    p_options.items.forEach(function(item) {
      updates[item.key] = 0;      
    });

    //console.log(updates);
    return new Promise(function(resolve, reject) {
      $.post('/cart/update.js', {
        updates: updates, 
        success: function() {
          resolve();
        }
      })
    });
  };
  
  methods.updateCartAttribute = function(p_options) {
    var update = {
      attributes: {}
    };
    
    update.attributes = p_options.attributes;
    
    return new Promise(function(resolve, reject) {
      $.ajax('/cart/update.js', {
        type: 'POST',        
        data: update, 
        success: function() {
          resolve();
        }
      })
    });
  };  
  
  return methods;
})(jQuery);  

(function($) {
  function initUpsellsApp() { 
    //console.log('init upsells!');

    // Filters
    Vue.filter('resize_image', function(src, size) {
      var resized = src || '';
      resized = resized.replace('.png', `_${size}.png`);
      resized = resized.replace('.jpg', `_${size}.jpg`);

      return resized;
    });

    Vue.filter('handleize', function(value) {
      return value.replace('-', ' ');    
    });

    Vue.filter('unhandleize', function(value) {
      return value.replace('-', ' ');
    });  

    Vue.filter('format_money', function(value) {
      const usd = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
      });

      return usd.format(value / 100);
    });

    if (document.querySelectorAll('#checkout-upsells').length) {
      var upsells = window['_upsells'] = new Vue({
        el: '#checkout-upsells',

        data: {
          productIdsInCart: [],        
          upsells: [],
          upsell_collection_handles: [
            {
              collection: 'bags',
              upsell_collection: 'bag-straps'
            },
            {
              collection: 'bag-straps',
              upsell_collection: 'clutches'
            },
            {
              collection: 'clutches',
              upsell_collection: 'keychains'
            },
            {
              collection: 'keychains',
              upsell_collection: 'last-call'
            }
          ],
          product_collections: JSON.parse(sessionStorage.getItem('product_collections')) || [],
          labels: {
            soldout: 'SOLD OUT',
            addToCart: 'Add to Cart',
            addedToCart: 'Added'
          },
          delays: {
            addToCartSuccess: 2500
          },
          addToCartSuccess: false
        },

        computed: {
          isCheckoutPage: function() {
            return window.location.pathname.indexOf('/checkouts/') !== -1;
          }
        },

        mounted: function() {
          var _this = this;
          // Check Cart and show upsells
          _this.loadUpsells();

          document.addEventListener('ajaxProduct:added', function(e) {
            //console.log(e);
            setTimeout(_this.loadUpsells, 0);
          });
          
          // on resize relocate
          $(window).on('resize', _.debounce(function() {
            _this.relocateUpsell();
          }, 100));
        },

        methods: {
          captureProductCollections: function(product_handle, collections) {
            var product_collections = JSON.parse(sessionStorage.getItem('product_collections')) || [];

            product_collections.push({
              product_handle: product_handle,
              collections: collections
            });

            sessionStorage.setItem('product_collections', JSON.stringify(product_collections));
          },

          refreshCartCheckout: function() {
            var _this = this;

            if (_this.isCheckoutPage) {
              // checkout page
              return new Promise(function(resolve, reject) { 
                var orderSummarySelector = '.product-table'; 
                var $orderSummary = $(orderSummarySelector); 

                var url = [window.location, orderSummarySelector].join(' '); 
                $orderSummary.load(url, function(response, status, xhr) { 
                  setTimeout(resolve, 0); 
                }); 
              });
            }
            else {
              return new Promise(function(resolve, reject) {
                var params = {url: '/cart/update.js?t='.concat(Date.now())};
                theme.cart._updateCart(params)
                .then(response => {
                  utils.refreshCart();
                })
                .catch(console.error)            
                
                setTimeout(function() {
                  $('#CartDrawer .drawer__scrollable').animate({scrollTop: 0}, "slow");
                }, 1000);
                setTimeout(resolve, 0); 
              });            
            }
          },

          updateTotals: function() {
            var _this = this;

            return new Promise(function(resolve, reject) { 
              if (!_this.isCheckoutPage) {
                setTimeout(resolve, 0); 
              }

              // checkout page
              var totalLinesSelector = '.order-summary__section--total-lines'; 
              var $totalLines = $(totalLinesSelector); 

              var url = [window.location, totalLinesSelector].join(' '); 
              $totalLines.load(url, function(response, status, xhr) { 
                setTimeout(resolve, 0); 
              }); 
            });
          },

          getCollectionProducts: function (handle) {
            return new Promise(function(resolve, reject) {
              $.ajax({
                url: `/collections/${handle}?view=checkout-upsell`,
                type: 'GET',
                cache: false
              })
              .done(function(response) {
                var script = document.createElement("script");
                script.text = response;
                //console.log(response);
                document.head.appendChild(script).parentNode.removeChild(script);
                resolve(_products);
              });            
            });
          },

          filterCartItemsByCollection: function(cart, collection_handle) {
            var _this = this;

            var productIdsInCart = cart.items.map(function(item) {
              return item.product_id;
            });

            _this.$set(_this, 'productIdsInCart', productIdsInCart);

            var items = cart.items.filter(function(item) {
              var flag = false;

              var p_collections = _this.product_collections.filter(function(o) {
                return item.url.indexOf(o.product_handle) !== -1;
              });

              if (p_collections.length) {
                flag = p_collections[0].collections.filter(function(collection) {
                  return collection == collection_handle;
                }).length !== 0;
              }

              return flag;
            });

            var items = cart.items.filter(function(item) {
              var flag = false;

              var p_collections = _this.product_collections.filter(function(o) {
                return item.url.indexOf(o.product_handle) !== -1;
              });

              if (p_collections.length) {
                flag = p_collections[0].collections.filter(function(collection) {
                  return collection == collection_handle;
                }).length !== 0;
              }

              return flag;
            });              
            return items;
          },

          loadUpsells: function() {
            console.log('loading cart/checkout upsells!');          
            var _this = this;
            var upsell_products = [];
            _this.$set(_this, 'upsells', []);  

            utils.getCart().then(function(cart) {
              async.eachSeries(_this.upsell_collection_handles, function(handle, callback) {
                _products = []; // clear products
                var mainCollectionItems = _this.filterCartItemsByCollection(cart, handle.collection);              
                var upsellCollectionItems = _this.filterCartItemsByCollection(cart, handle.upsell_collection);

                if (mainCollectionItems.length && !upsellCollectionItems.length) {
                  _this.getCollectionProducts(handle.upsell_collection).then(function(products) {
                    //console.log(handle);
                    // Filter items not in cart
                    upsell_products = upsell_products.concat(
                      products.filter(function(product) {
                        return _this.productIdsInCart.indexOf(product.id) == -1;
                      })
                    );
                    callback();
                  });
                }
                else {
                  callback();
                }
              }, function(err) {
                if (err) {
                  console.error(err);
                }

                // After all done
                _this.$set(_this, 'upsells', _.take(upsell_products, 3));  
                _this.relocateUpsell();              
              });
            });
          },

          relocateUpsell: function() {
            var _this = this;
            var isMobile = window.matchMedia("(max-width: 999px)").matches;
            var isCheckoutPage = _this.isCheckoutPage;

            if (isCheckoutPage) {
              if (!isMobile) {
                $('.order-summary__section--product-list').after($('#checkout-upsells'));
              }
              else {
                $('#order-summary').after($('#checkout-upsells'));
              }
            }
            else {
              $('#CartDrawer').find('[data-products]').after($('#checkout-upsells'));
            }
          },

          selectVariant: function(e, product) {
            var variant_id = $(e.currentTarget).val();
            var variants = product.variants.filter(function(v) {
              return v.id == variant_id;
            });
            product.selected_variant = variants.length ? variants[0] : null;
          },

          addItemToCart: function(e, product) {
            e.preventDefault();
            var _this = this;

            utils.addItemToCart({
              variant_id: product.selected_variant.id,
              quantity: 1,
              properties: {
                '__checkout-upsell': 'yes'
              }
            })
            .then(function() {
              var attributes = {};
              attributes[_this.isCheckoutPage ? '__checkout-upsell' : '__cartdrawer-upsell'] = 'yes';
              utils.updateCartAttribute({
                attributes: attributes
              });
            })
            .then(_this.refreshCartCheckout)
            .then(_this.updateTotals)
            .then(function() {
              _this.captureProductCollections(product.handle, product.collections);
              _this.loadUpsells();
            })
            .catch(function(error) {
              console.error(error);
            });
          }
        }
      });    
    }

    if (document.querySelectorAll('#product-upsells').length) {
      var product_upsells = window['_product_upsells'] = new Vue({
        el: '#product-upsells',

        data: {
          productIdsInCart: [],        
          upsells: [],
          product_collections: JSON.parse(sessionStorage.getItem('product_collections')) || [],
          labels: {
            soldout: 'SOLD OUT',
            addToCart: 'Add to Cart',
            addedToCart: 'Added'
          },
          delays: {
            addToCartSuccess: 2500
          },
          addToCartSuccess: false
        },

        computed: {},

        mounted: function() {
          var _this = this;

          // Check Cart and show upsells
          _this.loadUpsells();          
        },

        methods: {
          updateProductsInCart: function() {
            var _this = this;

            return new Promise(function(resolve, reject) {
              utils.getCart().then(function(cart) {
                var productIdsInCart = cart.items.map(function(item) {
                  return item.product_id;
                });

                _this.$set(_this, 'productIdsInCart', productIdsInCart);          
                resolve();
              });            
            });
          },

          captureProductCollections: function(product_handle, collections) {
            var product_collections = JSON.parse(sessionStorage.getItem('product_collections')) || [];

            product_collections.push({
              product_handle: product_handle,
              collections: collections
            });

            sessionStorage.setItem('product_collections', JSON.stringify(product_collections));
          },

          getCollectionProducts: function (handle) {
            return new Promise(function(resolve, reject) {
              $.ajax({
                url: `/collections/${handle}?view=checkout-upsell`,
                type: 'GET',
                cache: false
              })
              .done(function(response) {
                var script = document.createElement("script");
                script.text = response;
                //console.log(response);
                document.head.appendChild(script).parentNode.removeChild(script);
                resolve(_products);
              });            
            });
          },

          filterCartItemsByCollection: function(cart, collection_handle) {
            var _this = this;

            var productIdsInCart = cart.items.map(function(item) {
              return item.product_id;
            });

            _this.$set(_this, 'productIdsInCart', productIdsInCart);

            var items = cart.items.filter(function(item) {
              var flag = false;

              var p_collections = _this.product_collections.filter(function(o) {
                return item.url.indexOf(o.product_handle) !== -1;
              });

              if (p_collections.length) {
                flag = p_collections[0].collections.filter(function(collection) {
                  return collection == collection_handle;
                }).length !== 0;
              }

              return flag;
            });

            var items = cart.items.filter(function(item) {
              var flag = false;

              var p_collections = _this.product_collections.filter(function(o) {
                return item.url.indexOf(o.product_handle) !== -1;
              });

              if (p_collections.length) {
                flag = p_collections[0].collections.filter(function(collection) {
                  return collection == collection_handle;
                }).length !== 0;
              }

              return flag;
            });              
            return items;
          },

          loadUpsells: function() {
            console.log('loading product upsells!');
            var _this = this;
            var upsell_products = [];
            var isBagProduct = _product.type === 'bag';
            //console.log(isBagProduct);

            _this.$set(_this, 'upsells', []);          
            _this.updateProductsInCart();

            utils.getCart().then(function(cart) {
              var upsell_collections = isBagProduct ? ['bag-straps', 'clutches', 'keychains'] : ['bags', 'clutches', 'keychains'];

              async.each(upsell_collections, function(handle, callback) {
                //console.log(handle);
                _this.getCollectionProducts(handle).then(function(upsell_collection_products) {
                  _products = []; // clear products
                  // Filter items not in cart
                  var products = upsell_collection_products.filter(function(p) {
                    return _this.productIdsInCart.indexOf(p.id) == -1;
                  });

                  upsell_products.push(products[0]);

                  callback();
                });
              }, function(err) {
                if (err) {
                  console.error(err);
                }

                // After all done
                _this.$set(_this, 'upsells', upsell_products);  
              });
            });
          },

          selectVariant: function(e, product) {
            var variant_id = $(e.currentTarget).val();
            var variants = product.variants.filter(function(v) {
              return v.id == variant_id;
            });
            product.selected_variant = variants.length ? variants[0] : null;
          },

          addItemToCart: function(e, product) {
            e.preventDefault();
            var _this = this;

            utils.addItemToCart({
              variant_id: product.selected_variant.id,
              quantity: 1,
              properties: {
                '__checkout-upsell': 'yes'
              }
            })
            .then(function() {
              var attributes = {};
              attributes['__product-upsell'] = 'yes';
              utils.updateCartAttribute({
                attributes: attributes
              });
            })
            .then(_this.refreshCartCheckout)          
            .then(function() {
              //_this.loadUpsells();
            })
            .catch(function(error) {
              console.error(error);
            });
          },

          refreshCartCheckout: function() {
            return new Promise(function(resolve, reject) {
              var params = {url: '/cart/update.js?t='.concat(Date.now())};
              theme.cart._updateCart(params)
              .then(response => {
                utils.refreshCart();
              })
              .catch(console.error);              
              
              setTimeout(function() {
                $('#CartDrawer .drawer__scrollable').animate({scrollTop: 0}, "slow");
              }, 1000);
              setTimeout(resolve, 0); 
            });
          } 
        }
      });    
    }
  }

  $(document).ready(function() {
    initUpsellsApp();    
  });

  document.addEventListener('shopify:section:load', function (event) {
    initUpsellsApp();
  });
})(jQuery);